import { forwardRef } from "react";
import { CalendarDays, Clock, MapPin } from "lucide-react";
import { formatDate, formatTime } from "../lib/format";
import { sizeOf } from "../lib/inviteLayout";

const LINE = { title: 1.05, subheader: 1.4, details: 1.45, message: 1.45 };
const GAP = { subheader: 0.5, details: 1, message: 0.9 };

const Detail = ({ icon: Icon, children, testid }) => (
  <span data-testid={testid} className="flex items-start gap-[0.5em]">
    <Icon className="mt-[0.2em] h-[1em] w-[1em] shrink-0" />
    <span className="min-w-0 break-words">{children}</span>
  </span>
);

const CONTENT = {
  title: (ev) => <h1 data-testid="invite-occasion" className="font-display break-words font-extrabold">{ev.occasion || "Your occasion"}</h1>,
  subheader: (ev) => <p data-testid="invite-subheader" className="break-words font-medium">{ev.sub_header}</p>,
  details: (ev) => (
    <div data-testid="invite-details-lines" className="flex flex-col gap-[0.35em] font-semibold">
      {ev.date && <Detail icon={CalendarDays} testid="invite-date">{formatDate(ev.date)}</Detail>}
      {ev.time && <Detail icon={Clock} testid="invite-time">{formatTime(ev.time)}</Detail>}
      {ev.place && <Detail icon={MapPin} testid="invite-place">{ev.place}</Detail>}
    </div>
  ),
  message: (ev) => <p data-testid="invite-message" className="whitespace-pre-line break-words font-medium">{ev.message}</p>,
};

export const InviteText = forwardRef(({ kind, event, overlay, first = true, style, className = "", ...rest }, ref) => {
  const tone = overlay ? (kind === "title" ? "text-white" : "text-white/90") : kind === "title" ? "text-slate-900" : "text-slate-600";
  return (
    <div
      ref={ref}
      data-testid={`invite-el-${kind}`}
      className={`${tone} ${overlay ? "text-glow" : ""} ${className}`}
      style={{
        fontSize: `${sizeOf(event, kind)}cqw`,
        lineHeight: LINE[kind],
        color: event[`${kind}_color`] || undefined,
        marginTop: first ? 0 : `${GAP[kind]}em`,
        ...style,
      }}
      {...rest}
    >
      {CONTENT[kind](event)}
    </div>
  );
});
